import { Paper, Table, TableBody, TableContainer, TableFooter, TableHead, TableRow } from "@mui/material";
import React from "react";
import { TableComponents } from "react-virtuoso";

const VirtuosoTableComponents: TableComponents<any> = {
  Scroller: React.forwardRef<HTMLDivElement>((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => (
    <Table {...props} sx={{ borderCollapse: 'separate', }} />
  ),
  TableHead: React.forwardRef<HTMLTableSectionElement>((props, ref) => (
    <TableHead {...props} ref={ref} />
  )),
  TableRow: ({ item: _item, ...props }) => <TableRow {...props}/>,
  TableBody: React.forwardRef<HTMLTableSectionElement>((props, ref) => (
    <TableBody {...props} ref={ref} />
  )),
  TableFoot: React.forwardRef<HTMLTableSectionElement>((props, ref) => (
    <TableFooter {...props} ref={ref} />
  )),
};

export default VirtuosoTableComponents;